module.exports = __webpack_public_path__ + "static/media/a-bad-case-of-ux-lufc.68277c83.md";